export default __webpack_public_path__ + "static/media/appstore.b81f0ace.png";